/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, func } from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  setInviteId as setInviteIdAction,
  setSignupType as setSignupTypeAction,
  hideSignupModal as hideSignupModalAction,
} from 'actions/signup';

import { SIGNUP_STATUS } from 'reducers/user';

import ModalWrapper from 'components/ModalWrapper/ModalWrapper';

import ChooseType from './ChooseType/ChooseType';
import Authenticate from './Authenticate/Authenticate';

import styles from './signup-modal.scss';

/**
 * This is the SignupModal component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class SignupModal extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      params: shape({
        inviteId: string,
      }).isRequired,
    }).isRequired,
    user: object.isRequired,
    auth: shape({
      isAuthenticated: bool.isRequired,
    }).isRequired,
    signup: shape({
      type: string.isRequired,
      showModal: bool.isRequired,
    }).isRequired,
    setSignupType: func.isRequired,
    setInviteId: func.isRequired,
    hideSignupModal: func.isRequired,
  };

  /**
   * Create SignupModal.
   */
  constructor(props) {
    super(props);

    const { user } = this.props;

    this.state = {
      showAuthenticate: !!user.status,
    };
  }

  componentDidMount() {
    const {
      setInviteId,
      match: {
        params: { inviteId },
      },
    } = this.props;

    if (inviteId) {
      setInviteId(inviteId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      signup: { showModal: prevShowModal },
    } = prevProps;
    const {
      signup: { showModal },
    } = this.props;

    // On close modal.
    if (prevShowModal !== showModal && !showModal) {
      this.setState({ showAuthenticate: false });
    }
  }

  setSignupType = type => {
    const { setSignupType } = this.props;

    setSignupType(type);

    this.setState({ showAuthenticate: true });
  };

  renderStep() {
    const { showAuthenticate } = this.state;
    const { user, signup } = this.props;

    if (!showAuthenticate && !signup.type) {
      return <ChooseType setSignupType={this.setSignupType} />;
    }

    return (
      <Authenticate
        isInvite={!!signup.invite_id}
        submitText={'Create account'}
      />
    );
  }

  /**
   * Render SignupModal.
   *
   * @return {Object}
   */
  render() {
    const { showAuthenticate } = this.state;

    const {
      user,
      auth: { isAuthenticated },
      signup: { showModal },
      hideSignupModal,
    } = this.props;

    const { from } = location.state || { from: { pathname: '/' } };

    if (!showModal) return null;

    if (user.status === SIGNUP_STATUS.APPLICATION_APPROVED) {
      return <Redirect to={from} />;
    }

    if (isAuthenticated && !user.status) {
      return <Redirect to={from} />;
    }

    return (
      <ModalWrapper wide={showAuthenticate} hideModal={hideSignupModal}>
        <div className={styles.wrapper}>{this.renderStep()}</div>
      </ModalWrapper>
    );
  }
}

export default withRouter(
  connect(({ auth, user, signup }) => ({ auth, user, signup }), {
    setSignupType: setSignupTypeAction,
    setInviteId: setInviteIdAction,
    hideSignupModal: hideSignupModalAction,
  })(SignupModal)
);
